export default function ItemLabel({ item }) {

  return (
    <>
      <b>{item.displayName}:</b> {item.textValue}
    </>
  );
}

